<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

{#if $typing}
	<div class="typing-container">
		<div><img class="bot-icon" src="floraIconUpdate.svg" alt="logo" /></div>
		<div class="typing"><img src="typing.svg" alt="typing" /></div>
	</div>
{/if}

<script lang="ts">
	import type { Writable } from 'svelte/store';

	export let typing: Writable<boolean>;
</script>

<style>
	.typing {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.typing-container {
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.bot-icon {
		width: 21px;
		height: 24px;
		margin-left: 10px;
	}
</style>
